module.exports = __webpack_public_path__ + "img/logoletsgo.3a5e0be5.png";